import { gql } from '@apollo/client';

import { FileFragment } from './fragments';

const draftFileUploadMutation = gql`
  mutation uploadDraftFile($input: FileUploadInput!) {
    uploadDraftFile(input: $input) {
      ...File
    }
  }
  ${FileFragment}
`;

const editMediaFileMutation = gql`
  mutation editMediaFile($fileId: ObjectId!, $input: EditMediaFileInput!) {
    editMediaFile(fileId: $fileId, input: $input) {
      ...File
    }
  }
  ${FileFragment}
`;
export { draftFileUploadMutation, editMediaFileMutation };
